(function () {
  'use strict';

  var STORAGE_KEY = 'shopaleena_address';
  var EXPIRY_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  var STALE_MS = 48 * 60 * 60 * 1000; // 48 hours — prompt re-confirm after this
  var OTP_BASE = 'https://otp.shopaleena.com/api/';
  var otpResendTimer = 0;
  var otpTimerInterval = null;
  var currentStep = 1;
  var pendingAddress = {};
  var searchInitDone = false;

  // ── Saudi phone validation (mirrors checkout extension) ──
  function isValidSaudiPhone(phone) {
    if (!phone) return false;
    var clean = phone.replace(/[\s\-\(\)]/g, '');
    return (
      /^[5][0-9]{8}$/.test(clean) ||
      /^0[5][0-9]{8}$/.test(clean) ||
      /^966[5][0-9]{8}$/.test(clean) ||
      /^\+966[5][0-9]{8}$/.test(clean)
    );
  }

  function formatSaudiPhone(phone) {
    if (!phone) return phone;
    var clean = phone.replace(/[\s\-\(\)]/g, '');
    if (/^[5][0-9]{8}$/.test(clean)) return '+966' + clean;
    if (/^0[5][0-9]{8}$/.test(clean)) return '+966' + clean.substring(1);
    if (/^966[5][0-9]{8}$/.test(clean)) return '+' + clean;
    if (/^\+966[5][0-9]{8}$/.test(clean)) return clean;
    return phone;
  }

  // ── localStorage helpers ──
  function getSavedAddress() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.timestamp) return null;
      if (Date.now() - parsed.timestamp > EXPIRY_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveAddress(data) {
    try {
      data.timestamp = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function isStaleAddress(saved) {
    return saved && saved.timestamp && (Date.now() - saved.timestamp) > STALE_MS;
  }

  // ── Cart attributes bridge ──
  function pushToCartAttributes(data) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _address_address1: data.address1 || '',
          _address_city: data.city || '',
          _address_neighbourhood: data.neighbourhood || '',
          _address_zip: data.zip || '',
          _address_national: data.national_address || '',
          _address_country: data.country || 'Saudi Arabia',
          _address_country_code: data.country_code || 'SA',
          _address_lat: data.lat ? String(data.lat) : '',
          _address_lng: data.lng ? String(data.lng) : ''
        }
      })
    }).catch(function (e) {
      console.warn('[address-picker] cart attributes push failed:', e);
    });
  }

  // ── Popup DOM helpers ──
  function getPopup() { return document.getElementById('address-picker-popup'); }
  function getPanel(n) { return getPopup().querySelector('[data-panel="' + n + '"]'); }

  function openPopup() {
    var popup = getPopup();
    if (!popup) return;
    pendingAddress = {};
    showAddressPreview('');
    popup.removeAttribute('aria-hidden');
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setStep(1);
    initMap();
  }

  var _closingAfterSave = false;
  function closePopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-open');
    clearInterval(otpTimerInterval);
    document.body.style.overflow = '';
    // Fire cancel event only when closed without saving (not from finishAndSave)
    if (!_closingAfterSave) {
      document.dispatchEvent(new CustomEvent('address-picker:closed-without-save'));
    }
    _closingAfterSave = false;
  }

  // ── Stale-address: open form pre-filled so customer can confirm or edit ──
  function openStalePopup(saved) {
    var popup = getPopup();
    if (!popup) return;

    // Load saved data into pendingAddress so prefillFormFromGeocode can use it
    pendingAddress = Object.assign({}, saved);

    popup.removeAttribute('aria-hidden');
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Go straight to Step 2 (form), skipping the map
    setStep(2);
    // Pre-fill all form fields from the saved address
    prefillFormFromGeocode();
  }

  function setStep(n) {
    var i18n = window.addressPickerI18n || {};
    currentStep = n;
    var titles = [i18n.step1Title, i18n.step2Title, i18n.step3Title];
    var heading = getPopup().querySelector('#address-picker-title');
    if (heading) heading.textContent = titles[n - 1] || '';

    // Update step indicators
    getPopup().querySelectorAll('.address-picker-step').forEach(function (el) {
      var s = parseInt(el.getAttribute('data-step'), 10);
      el.classList.toggle('address-picker-step--active', s === n);
      el.classList.toggle('address-picker-step--done', s < n);
    });

    // Show/hide panels
    [1, 2, 3].forEach(function (p) {
      var panel = getPanel(p);
      if (!panel) return;
      if (p === n) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function showError(field, msg) {
    var el = getPopup().querySelector('[data-error="' + field + '"]');
    if (el) el.textContent = msg || '';
    var input = getPopup().querySelector('[name="' + field + '"]');
    if (input) input.classList.toggle('has-error', !!msg);
  }

  function clearErrors() {
    getPopup().querySelectorAll('.address-picker-error').forEach(function (el) { el.textContent = ''; });
    getPopup().querySelectorAll('.address-picker-input').forEach(function (el) { el.classList.remove('has-error'); });
  }

  // ── Label text population ──
  function populateLabels() {
    var i18n = window.addressPickerI18n || {};
    var popup = getPopup();
    if (!popup) return;

    // Main heading
    var h = popup.querySelector('#address-picker-title');
    if (h) h.textContent = i18n.step1Title || '';

    // Location button
    var locBtn = popup.querySelector('.address-picker-location-label');
    if (locBtn) locBtn.textContent = i18n.useMyLocation || '';

    // Next button (step 1)
    var nextBtn = popup.querySelector('[data-go="2"]');
    if (nextBtn) nextBtn.textContent = i18n.next || '';

    // Labels by for attribute
    var labelMap = {
      'ap-city-search': i18n.city,
      'ap-address1': i18n.address1,
      'ap-neighbourhood': i18n.neighbourhood,
      'ap-zip': i18n.zip,
      'ap-national': i18n.nationalAddress,
      'ap-otp': i18n.otpPlaceholder
    };
    Object.keys(labelMap).forEach(function (id) {
      var label = popup.querySelector('label[for="' + id + '"]');
      if (label) label.textContent = labelMap[id] || '';
      var input = popup.getElementById ? popup.getElementById(id) : document.getElementById(id);
      if (!input) input = popup.querySelector('#' + id);
      if (input && input.tagName === 'INPUT') input.placeholder = labelMap[id] || '';
    });

    // Submit button
    var submitBtn = popup.querySelector('.address-picker-submit-btn');
    if (submitBtn) submitBtn.textContent = i18n.verifySave || '';

    // Back button (step 2 → step 1)
    var backBtn = popup.querySelector('.address-picker-back-btn');
    if (backBtn) backBtn.textContent = i18n.back || 'Back to map';

    // OTP verify button
    var otpVerifyBtn = popup.querySelector('.address-picker-otp-verify-btn');
    if (otpVerifyBtn) otpVerifyBtn.textContent = i18n.otpVerify || '';

    // Init searchable city dropdown
    initCitySearch(popup);
    initNeighbourhoodDropdown(popup);
  }

  // ── Language helper ──
  function getLang() {
    var popup = getPopup();
    var lang = popup ? popup.getAttribute('data-lang') : '';
    if (!lang) lang = document.documentElement.lang || 'en';
    return lang.split('-')[0].toLowerCase();
  }

  // National address code pattern: 4 letters + 4 digits (e.g. RHWA3634, RGMA2933)
  var NATIONAL_ADDRESS_RE = /\b([A-Z]{4}\d{4})\b/;

  // ── Address component parser ──
  function parseAddressComponents(components, formattedAddress) {
    var parsed = {};
    var premise = '';
    (components || []).forEach(function (c) {
      if (c.types.includes('route')) parsed.address1 = c.long_name;
      if (c.types.includes('sublocality_level_1') || c.types.includes('neighborhood')) parsed.neighbourhood = c.long_name;
      // locality takes priority over administrative_area_level_2
      if (c.types.includes('locality')) parsed.city = c.long_name;
      if (!parsed.city && c.types.includes('administrative_area_level_2')) parsed.city = c.long_name;
      if (c.types.includes('postal_code')) parsed.zip = c.long_name;
      if (c.types.includes('street_number')) parsed.street_number = c.long_name;
      if (c.types.includes('country')) parsed.country = c.long_name;
      // premise often holds the national address code (e.g. RGMA2933)
      if (c.types.includes('premise')) premise = c.long_name;
    });
    if (parsed.street_number && parsed.address1) {
      parsed.address1 = parsed.street_number + ' ' + parsed.address1;
    }
    if (!parsed.address1 && formattedAddress) {
      parsed.address1 = formattedAddress.split('،')[0].split(',')[0].trim();
    }
    // Strip Arabic neighbourhood prefix "حي " if present
    if (parsed.neighbourhood) {
      parsed.neighbourhood = parsed.neighbourhood.replace(/^حي\s+/, '');
    }
    // Extract national address code: try premise field first, then formatted address
    var naMatch = NATIONAL_ADDRESS_RE.exec(premise) ||
                  (formattedAddress ? NATIONAL_ADDRESS_RE.exec(formattedAddress) : null);
    if (naMatch) parsed.national_address = naMatch[1];

    // Normalize Arabic city name → English for select matching
    if (parsed.city) {
      var i18n = window.addressPickerI18n || {};
      var arCities = i18n.citiesAr || [];
      var enCities = i18n.citiesEn || [];
      var idx = arCities.indexOf(parsed.city);
      if (idx !== -1) parsed.city = enCities[idx];
    }
    return parsed;
  }

  // ── Google Maps + Places ──
  var mapsLoaded = false;
  var mapInstance = null;
  var markerInstance = null;

  function loadGoogleMaps(apiKey) {
    if (mapsLoaded || window.google) { initMapInstance(); return; }
    var lang = getLang();
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places&language=' + encodeURIComponent(lang) + '&callback=addressPickerMapsReady';
    s.async = true;
    s.defer = true;
    s.onerror = function () {
      console.error('[address-picker] Google Maps script failed to load. Check API key, billing, and HTTP referrer restrictions in Google Cloud Console.');
    };
    window.addressPickerMapsReady = function () {
      mapsLoaded = true;
      initMapInstance();
    };
    document.head.appendChild(s);
  }

  function initMapInstance() {
    var container = document.getElementById('address-picker-map');
    if (!container || !window.google) return;
    if (mapInstance) {
      setTimeout(function () {
        google.maps.event.trigger(mapInstance, 'resize');
        if (markerInstance && markerInstance.getVisible()) {
          mapInstance.setCenter(markerInstance.getPosition());
        }
      }, 150);
      return;
    }
    mapInstance = new google.maps.Map(container, {
      center: { lat: 23.8859, lng: 45.0792 },
      zoom: 6,
      zoomControl: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false
    });
    var defaultLat = 24.7136, defaultLng = 46.6753; // Riyadh city center
    markerInstance = new google.maps.Marker({
      map: mapInstance,
      position: { lat: defaultLat, lng: defaultLng },
      draggable: true,
      visible: true
    });
    pendingAddress.lat = defaultLat;
    pendingAddress.lng = defaultLng;
    reverseGeocode(defaultLat, defaultLng);

    mapInstance.addListener('click', function (e) {
      // Suppress POI info windows and use the click location
      if (e.placeId) e.stop();
      placeMarker(e.latLng.lat(), e.latLng.lng());
    });
    markerInstance.addListener('dragend', function () {
      var pos = markerInstance.getPosition();
      reverseGeocode(pos.lat(), pos.lng());
    });
    initSearch();
  }

  function initSearch() {
    if (searchInitDone) return;
    searchInitDone = true;
    var input = document.getElementById('address-picker-search');
    if (!input || !window.google || !google.maps.places) return;
    var isArabic = window.addressPickerI18n && window.addressPickerI18n.isArabic;
    if (isArabic) input.setAttribute('dir', 'rtl');
    var autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'sa' },
      fields: ['geometry', 'address_components', 'formatted_address']
    });
    if (isArabic) {
      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.classList && node.classList.contains('pac-container')) {
              node.setAttribute('dir', 'rtl');
              obs.disconnect();
            }
          });
        });
      });
      obs.observe(document.body, { childList: true });
    }
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) return;
      var lat = place.geometry.location.lat();
      var lng = place.geometry.location.lng();
      var parsed = parseAddressComponents(place.address_components, place.formatted_address);
      pendingAddress = Object.assign(pendingAddress, parsed);
      pendingAddress.lat = lat;
      pendingAddress.lng = lng;
      showAddressPreview();
      if (mapInstance) {
        mapInstance.setCenter({ lat: lat, lng: lng });
        mapInstance.setZoom(15);
        placeMarker(lat, lng);
      }
    });
  }

  function placeMarker(lat, lng) {
    if (!markerInstance) return;
    var latLng = new google.maps.LatLng(lat, lng);
    markerInstance.setPosition(latLng);
    markerInstance.setVisible(true);
    pendingAddress.lat = lat;
    pendingAddress.lng = lng;
    reverseGeocode(lat, lng);
  }

  var geocoderInstance = null;
  var geocodePending = false;

  function showAddressPreview(formattedAddress) {
    var preview = document.getElementById('address-picker-preview');
    var previewText = document.getElementById('address-picker-preview-text');
    if (!preview || !previewText) return;
    if (!formattedAddress && !pendingAddress.address1) {
      preview.setAttribute('hidden', '');
      return;
    }
    var parts = [];
    if (pendingAddress.address1) parts.push(pendingAddress.address1);
    if (pendingAddress.neighbourhood) parts.push(pendingAddress.neighbourhood);
    if (pendingAddress.city) {
      // Show city in current language
      var i18n = window.addressPickerI18n || {};
      var enCities = i18n.citiesEn || [];
      var arCities = i18n.citiesAr || [];
      var cityDisplay = pendingAddress.city;
      if (i18n.isArabic) {
        var ci = enCities.indexOf(pendingAddress.city);
        if (ci !== -1) cityDisplay = arCities[ci];
      }
      parts.push(cityDisplay);
    }
    if (pendingAddress.zip) parts.push(pendingAddress.zip);
    if (pendingAddress.national_address) parts.push(pendingAddress.national_address);
    if (pendingAddress.country) parts.push(pendingAddress.country);
    var isArabic = window.addressPickerI18n && window.addressPickerI18n.isArabic;
    previewText.textContent = parts.join(isArabic ? '، ' : ', ');
    preview.removeAttribute('hidden');
  }

  function reverseGeocode(lat, lng) {
    if (!window.google || !google.maps.Geocoder) return;
    if (!geocoderInstance) geocoderInstance = new google.maps.Geocoder();
    var lang = getLang();
    geocodePending = true;
    geocoderInstance.geocode(
      { location: { lat: lat, lng: lng }, language: lang },
      function (results, status) {
        geocodePending = false;
        if (status !== 'OK' || !results || !results[0]) {
          console.warn('[address-picker] reverse geocode status:', status);
          return;
        }
        var parsed = parseAddressComponents(results[0].address_components, results[0].formatted_address);
        pendingAddress = Object.assign(pendingAddress, parsed);
        showAddressPreview();
      }
    );
  }

  function initMap() {
    var popup = getPopup();
    if (!popup) return;
    var apiKey = popup.getAttribute('data-maps-key');
    if (!apiKey) return;
    if (window.google && mapInstance) {
      setTimeout(function () {
        google.maps.event.trigger(mapInstance, 'resize');
        if (markerInstance && markerInstance.getVisible()) {
          mapInstance.setCenter(markerInstance.getPosition());
        }
      }, 150);
      return;
    }
    loadGoogleMaps(apiKey);
  }

  // ── Form validation ──
  function validateForm() {
    var i18n = window.addressPickerI18n || {};
    var popup = getPopup();
    var valid = true;
    clearErrors();
    var required = ['address1', 'city'];
    required.forEach(function (field) {
      var input = popup.querySelector('[name="' + field + '"]');
      if (!input || !input.value.trim()) {
        showError(field, i18n.errorRequired || 'Required');
        valid = false;
      }
    });
    return valid;
  }

  function readFormData() {
    var popup = getPopup();
    var fields = ['address1', 'city', 'neighbourhood', 'zip', 'national_address'];
    var data = {};
    fields.forEach(function (f) {
      var el = popup.querySelector('[name="' + f + '"]');
      data[f] = el ? el.value.trim() : '';
    });
    data.lat = pendingAddress.lat || null;
    data.lng = pendingAddress.lng || null;
    data.country = 'Saudi Arabia';
    data.country_code = 'SA';
    return data;
  }

  function prefillFormFromGeocode() {
    var popup = getPopup();
    if (!pendingAddress) return;

    // Text inputs
    var textFields = ['address1', 'zip', 'national_address'];
    textFields.forEach(function (key) {
      if (pendingAddress[key]) {
        var el = popup.querySelector('[name="' + key + '"]');
        if (el) el.value = pendingAddress[key];
      }
    });

    // City searchable dropdown
    if (pendingAddress.city) {
      setCityValue(popup, pendingAddress.city);
    }

    // Pre-select neighbourhood if geocode returned one
    if (pendingAddress.neighbourhood) {
      var nbSelect = popup.querySelector('#ap-neighbourhood');
      if (nbSelect && nbSelect.tagName === 'SELECT') {
        var nbVal = pendingAddress.neighbourhood;
        for (var i = 0; i < nbSelect.options.length; i++) {
          if (nbSelect.options[i].value.toLowerCase() === nbVal.toLowerCase()) {
            nbSelect.selectedIndex = i;
            break;
          }
        }
      }
    }
  }

  function initCitySearch(popup) {
    var i18n = window.addressPickerI18n || {};
    var isArabic = i18n.isArabic;
    var displayCities = isArabic ? (i18n.citiesAr || []) : (i18n.citiesEn || []);
    var enCities = i18n.citiesEn || [];

    var searchInput = popup.querySelector('#ap-city-search');
    var hiddenInput = popup.querySelector('#ap-city');
    var dropdown = popup.querySelector('.address-picker-city-dropdown');
    if (!searchInput || !hiddenInput || !dropdown) return;

    searchInput.placeholder = i18n.selectCityPlaceholder || '';

    function renderList(filter) {
      dropdown.innerHTML = '';
      var shown = 0;
      displayCities.forEach(function (label, idx) {
        if (filter && label.toLowerCase().indexOf(filter.toLowerCase()) === -1 &&
            enCities[idx].toLowerCase().indexOf(filter.toLowerCase()) === -1) return;
        var li = document.createElement('li');
        li.textContent = label;
        li.setAttribute('data-value', enCities[idx] || label);
        if (hiddenInput.value === (enCities[idx] || label)) li.classList.add('is-active');
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          var enValue = li.getAttribute('data-value');
          hiddenInput.value = enValue;
          searchInput.value = label;
          dropdown.setAttribute('hidden', '');
          showError('city', '');
          populateNeighbourhoods(popup, enValue);
        });
        dropdown.appendChild(li);
        shown++;
      });
      if (shown > 0) dropdown.removeAttribute('hidden');
      else dropdown.setAttribute('hidden', '');
    }

    searchInput.addEventListener('focus', function () { renderList(searchInput.value); });
    searchInput.addEventListener('input', function () { renderList(searchInput.value); hiddenInput.value = ''; });
    searchInput.addEventListener('blur', function () {
      setTimeout(function () { dropdown.setAttribute('hidden', ''); }, 180);
    });
  }

  function initNeighbourhoodDropdown(popup) {
    var oldInput = popup.querySelector('#ap-neighbourhood');
    if (!oldInput || oldInput.tagName === 'SELECT') return; // already initialised

    var select = document.createElement('select');
    select.id = 'ap-neighbourhood';
    select.name = 'neighbourhood';
    select.className = oldInput.className;
    select.setAttribute('dir', 'auto');
    select.disabled = true;

    var placeholder = document.createElement('option');
    var i18n = window.addressPickerI18n || {};
    placeholder.value = '';
    placeholder.textContent = i18n.neighbourhood || 'Neighbourhood';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    oldInput.parentNode.replaceChild(select, oldInput);
  }

  function populateNeighbourhoods(popup, enCityName) {
    var select = popup.querySelector('#ap-neighbourhood');
    if (!select || select.tagName !== 'SELECT') return;

    var i18n = window.addressPickerI18n || {};
    var isArabic = i18n.isArabic;
    var nbEn = (i18n.neighbourhoodsEn || {})[enCityName] || [];
    var nbAr = (i18n.neighbourhoodsAr || {})[enCityName] || [];

    // Clear existing options (keep placeholder at index 0)
    while (select.options.length > 1) select.remove(1);

    if (nbEn.length === 0) {
      select.disabled = true;
      select.selectedIndex = 0;
      return;
    }

    nbEn.forEach(function (enName, idx) {
      var opt = document.createElement('option');
      opt.value = enName;
      opt.textContent = isArabic ? (nbAr[idx] || enName) : enName;
      select.appendChild(opt);
    });

    select.disabled = false;
    select.selectedIndex = 0; // placeholder selected until user picks
  }

  function setCityValue(popup, enCityValue) {
    var i18n = window.addressPickerI18n || {};
    var isArabic = i18n.isArabic;
    var enCities = i18n.citiesEn || [];
    var arCities = i18n.citiesAr || [];
    var hiddenInput = popup.querySelector('#ap-city');
    var searchInput = popup.querySelector('#ap-city-search');
    if (!hiddenInput || !searchInput) return;
    // Find index in enCities (case-insensitive)
    var idx = -1;
    for (var i = 0; i < enCities.length; i++) {
      if (enCities[i].toLowerCase() === enCityValue.toLowerCase()) { idx = i; break; }
    }
    if (idx !== -1) {
      hiddenInput.value = enCities[idx];
      searchInput.value = isArabic ? (arCities[idx] || enCities[idx]) : enCities[idx];
      populateNeighbourhoods(popup, enCities[idx]);
    } else {
      hiddenInput.value = enCityValue;
      searchInput.value = enCityValue;
      populateNeighbourhoods(popup, enCityValue);
    }
  }

  // ── OTP flow ──
  function sendOtp(phone) {
    var formData = new FormData();
    formData.append('phone_number', phone);
    return fetch(OTP_BASE + 'otp-send', {
      method: 'POST',
      body: formData,
      cache: 'no-cache'
    }).then(function (r) { return r.json(); });
  }

  function validateOtp(phone, code) {
    var formData = new FormData();
    formData.append('phone_number', phone);
    formData.append('otp_code', code);
    return fetch(OTP_BASE + 'otp-validate/', {
      method: 'POST',
      body: formData,
      cache: 'no-cache'
    }).then(function (r) { return r.json(); });
  }

  function startOtpTimer() {
    var i18n = window.addressPickerI18n || {};
    otpResendTimer = 60;
    clearInterval(otpTimerInterval);
    var timerEl = getPopup().querySelector('.address-picker-otp-timer');
    var resendBtn = getPopup().querySelector('.address-picker-otp-resend-btn');
    if (resendBtn) resendBtn.setAttribute('hidden', '');
    otpTimerInterval = setInterval(function () {
      otpResendTimer--;
      if (timerEl) {
        timerEl.removeAttribute('hidden');
        timerEl.textContent = (i18n.otpResendIn || 'Resend in {{seconds}}s').replace('{{seconds}}', otpResendTimer);
      }
      if (otpResendTimer <= 0) {
        clearInterval(otpTimerInterval);
        if (timerEl) timerEl.setAttribute('hidden', '');
        if (resendBtn) resendBtn.removeAttribute('hidden');
      }
    }, 1000);
  }

  function finishAndSave(addressData) {
    saveAddress(addressData);
    pushToCartAttributes(addressData);
    _closingAfterSave = true;
    closePopup();
    document.dispatchEvent(new CustomEvent('address-picker:saved', { detail: addressData }));
  }

  // ── Event binding ──
  function bindEvents() {
    var popup = getPopup();
    if (!popup) return;

    // Close button
    var closeBtn = popup.querySelector('.address-picker-close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    // Click overlay to close
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    // Step 1 → Step 2
    var nextBtn = popup.querySelector('[data-go="2"]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (geocodePending) {
          // Wait up to 2s for geocode to finish, then proceed
          var waited = 0;
          nextBtn.classList.add('is-loading');
          var poll = setInterval(function () {
            waited += 100;
            if (!geocodePending || waited >= 2000) {
              clearInterval(poll);
              nextBtn.classList.remove('is-loading');
              prefillFormFromGeocode();
              setStep(2);
            }
          }, 100);
        } else {
          prefillFormFromGeocode();
          setStep(2);
        }
      });
    }

    // Step 2 → Step 1 (back to map)
    var backBtn = popup.querySelector('.address-picker-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        setStep(1);
        if (mapInstance) {
          // Map already initialised — just trigger resize so tiles render
          setTimeout(function () {
            google.maps.event.trigger(mapInstance, 'resize');
          }, 150);
        } else {
          // Opened via stale-address shortcut — map never initialised yet
          initMap();
        }
      });
    }

    // Use my location — GPS
    var locBtn = popup.querySelector('.address-picker-location-btn');
    if (locBtn) {
      locBtn.addEventListener('click', function () {
        if (!navigator.geolocation) return;
        locBtn.classList.add('is-loading');
        navigator.geolocation.getCurrentPosition(function (pos) {
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;
          locBtn.classList.remove('is-loading');
          if (mapInstance) {
            mapInstance.setCenter({ lat: lat, lng: lng });
            mapInstance.setZoom(15);
          }
          placeMarker(lat, lng);
        }, function () {
          locBtn.classList.remove('is-loading');
        });
      });
    }

    // Form submit → save directly (no OTP needed)
    var form = popup.querySelector('#address-picker-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validateForm()) return;
        var data = readFormData();
        pendingAddress = Object.assign(pendingAddress, data);
        var submitBtn = form.querySelector('.address-picker-submit-btn');
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
        setTimeout(function () {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
          finishAndSave(pendingAddress);
        }, 300);
      });
    }

    // OTP verify
    var otpVerifyBtn = popup.querySelector('.address-picker-otp-verify-btn');
    if (otpVerifyBtn) {
      otpVerifyBtn.addEventListener('click', function () {
        var otpInput = popup.querySelector('#ap-otp');
        var code = otpInput ? otpInput.value.trim() : '';
        if (!code) { showError('otp', window.addressPickerI18n.errorRequired || 'Required'); return; }
        otpVerifyBtn.classList.add('is-loading');
        otpVerifyBtn.disabled = true;
        validateOtp(pendingAddress.phone, code)
          .then(function (res) {
            otpVerifyBtn.classList.remove('is-loading');
            otpVerifyBtn.disabled = false;
            if (res.otp_validation === 'valid') {
              finishAndSave(pendingAddress);
            } else {
              showError('otp', window.addressPickerI18n.errorOtpInvalid || 'Invalid code');
            }
          })
          .catch(function () {
            otpVerifyBtn.classList.remove('is-loading');
            otpVerifyBtn.disabled = false;
            finishAndSave(pendingAddress);
          });
      });
    }

    // OTP resend
    var resendBtn = popup.querySelector('.address-picker-otp-resend-btn');
    if (resendBtn) {
      resendBtn.textContent = window.addressPickerI18n.otpResend || 'Resend';
      resendBtn.addEventListener('click', function () {
        resendBtn.classList.add('is-loading');
        sendOtp(pendingAddress.phone)
          .then(function () {
            resendBtn.classList.remove('is-loading');
            startOtpTimer();
          })
          .catch(function () { resendBtn.classList.remove('is-loading'); });
      });
    }

    // Checkout intercept — show stale-address form before proceeding to checkout
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest
        ? e.target.closest('[name="checkout"], [href*="/checkout"], .checkout-button, #checkout, .cart__checkout')
        : null;
      if (!el) return;
      var saved = getSavedAddress();
      if (saved && isStaleAddress(saved)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openStalePopup(saved);
        // After form is saved, resume navigation to checkout
        document.addEventListener('address-picker:saved', function goCheckout() {
          document.removeEventListener('address-picker:saved', goCheckout);
          window.location.href = '/checkout';
        });
      }
    }, true); // capture so we intercept before other listeners

    // ── Intercept every add-to-cart fetch — works for ALL paths on the site ──
    // (product form, quick-buy, express-delivery, try-on, etc.)
    var _origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method || (input && input.method) || 'GET').toUpperCase();
      var isAddToCart = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (!isAddToCart) return _origFetch.apply(this, arguments);

      var saved = getSavedAddress();
      if (saved) {
        // Address already known — push to attributes and let fetch proceed normally
        pushToCartAttributes(saved);
        return _origFetch.apply(this, arguments);
      }

      // No address yet — show popup, then replay the fetch after address is saved
      var fetchArgs = arguments;
      return new Promise(function (resolve, reject) {
        // Store the original fetch args to replay after address is collected
        function onSaved() {
          document.removeEventListener('address-picker:saved', onSaved);
          document.removeEventListener('address-picker:closed-without-save', onCancel);
          pushToCartAttributes(getSavedAddress());
          _origFetch.apply(window, fetchArgs).then(resolve).catch(reject);
        }
        function onCancel() {
          document.removeEventListener('address-picker:saved', onSaved);
          document.removeEventListener('address-picker:closed-without-save', onCancel);
          // Replay anyway so the cart still works
          _origFetch.apply(window, fetchArgs).then(resolve).catch(reject);
        }
        document.addEventListener('address-picker:saved', onSaved);
        document.addEventListener('address-picker:closed-without-save', onCancel);
        openPopup();
      });
    };
  }

  // ── Trigger on page load ──
  function shouldShowOnLoad() {
    var saved = getSavedAddress();
    if (saved) {
      pushToCartAttributes(saved);
      return false;
    }
    return true;
  }

  function init() {
    var popup = getPopup();
    if (!popup) return;
    populateLabels();
    bindEvents();

    var isCartPage = document.body.classList.contains('template-cart') ||
                     window.location.pathname === '/cart';

    if (isCartPage) {
      if (shouldShowOnLoad()) {
        openPopup();
      }
      return;
    }

    // On non-cart pages: push saved address to cart attributes silently.
    // Do NOT auto-open popup — it will open on first add-to-cart (via cart drawer intercept).
    var saved = getSavedAddress();
    if (saved) {
      pushToCartAttributes(saved);
    }
  }

  window.AddressPicker = { init: init, open: openPopup, close: closePopup };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
